import { flattenKubernetesTargets } from '../attacks/create/targets/kubernetes/kubernetes-target-utils'
import { getContainersFromClients } from '../attacks/create/targets/target-utils'

import { Client, Container, K8sObject, Service, ServiceProvenance } from 'api'

export enum Provenance {
  PROCESSDATA = 'PROCESSDATA',
  CONTAINER = 'CONTAINER',
  KUBERNETES = 'KUBERNETES'
}

export function getDisplayableTargetType(
  service: Service
): 'Hosts' | 'Containers' | 'Kubernetes' {
  switch (getServiceProvenance(service)) {
    case 'PROCESSDATA':
      return 'Hosts'
    case 'CONTAINER':
      return 'Containers'
    case 'KUBERNETES':
      return 'Kubernetes'
  }
}

export function getServiceProvenance(service: Service): ServiceProvenance {
  return service.provenance
}

type ServiceActiveTargets = Client[] | Container[] | K8sObject[]

export function getServiceActiveTargets(
  service: Service
): ServiceActiveTargets {
  const provenance = service.provenance
  const targets = service.activeTargets

  switch (provenance) {
    case 'KUBERNETES':
      return flattenKubernetesTargets(targets.k8sClients) as K8sObject[]
    case 'PROCESSDATA':
      return targets.clients
    case 'CONTAINER':
      return getContainersFromClients(targets.clients)
    default:
      return []
  }
}

export function getActiveTargetCount(service: Service): number {
  const targets = getServiceActiveTargets(service)
  return targets.length
}
